import { getApiUrl } from "../config";
import type { GetWalletAlertsResponse, GetWalletAlertHistoryResponse, MarkAlertHistorySeenDto, GetUnseenAlertCountResponse, MarkAllAlertHistorySeenResponse, ReorderWalletAlertsDto, ReorderWalletAlertsResponse, EnableDisableAlertResponse } from "@server/routes/wallet-alert/dto";

export const fetchWalletAlerts = async (page: number = 1, limit: number = 10): Promise<GetWalletAlertsResponse> => {
    const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
    });
    
    const res = await fetch(getApiUrl(`/api/wallet-alerts?${params}`), {
        credentials: 'include',
    });
    
    if (!res.ok) {
        throw new Error('Failed to fetch wallet alerts')
    }
    return res.json();
};

export const fetchWalletAlertHistory = async (page: number = 1, limit: number = 10): Promise<GetWalletAlertHistoryResponse> => {
    const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
    });
    
    const res = await fetch(getApiUrl(`/api/wallet-alerts/history?${params}`), {
        credentials: 'include',
    });

    if (!res.ok) {
        throw new Error('Failed to fetch wallet alert history')
    }
    
    return res.json();
};

export const markAlertHistoryAsSeen = async (ids: number[]): Promise<{ success: boolean; updatedCount: number; updatedIds: number[] }> => {
    const res = await fetch(getApiUrl('/api/wallet-alerts/history/mark-seen'), {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({ ids }),
    });

    if (!res.ok) {
        throw new Error('Failed to mark alert history as seen');
    }

    return res.json();
};

export const markAllAlertHistoryAsSeen = async (): Promise<MarkAllAlertHistorySeenResponse> => {
    const res = await fetch(getApiUrl('/api/wallet-alerts/history/mark-all-seen'), {
        method: 'PATCH',
        credentials: 'include',
    });

    if (!res.ok) {
        throw new Error('Failed to mark all alert history as seen');
    }

    return res.json();
};

export const fetchUnseenAlertCount = async (): Promise<GetUnseenAlertCountResponse> => {
    const res = await fetch(getApiUrl('/api/wallet-alerts/history/unseen-count'), {
        credentials: 'include',
    });

    if (!res.ok) {
        throw new Error('Failed to fetch unseen alert count');
    }

    return res.json();
};

export const reorderWalletAlerts = async (alertOrders: ReorderWalletAlertsDto["alertOrders"]): Promise<ReorderWalletAlertsResponse> => {
    const res = await fetch(getApiUrl("/api/wallet-alerts/reorder"), {
        method: "PATCH",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: 'include',
        body: JSON.stringify({ alertOrders }),
    });

    if (!res.ok) {
        throw new Error("Failed to reorder wallet alerts");
    }

    return res.json();
};

export const enableWalletAlert = async (alertId: number): Promise<EnableDisableAlertResponse> => {
    const res = await fetch(getApiUrl(`/api/wallet-alerts/${alertId}/enable`), {
        method: "PATCH",
        credentials: 'include',
    });

    if (!res.ok) {
        throw new Error("Failed to enable wallet alert");
    }

    return res.json();
};

export const disableWalletAlert = async (alertId: number): Promise<EnableDisableAlertResponse> => {
    const res = await fetch(getApiUrl(`/api/wallet-alerts/${alertId}/disable`), {
        method: "PATCH",
        credentials: 'include',
    });

    if (!res.ok) {
        throw new Error("Failed to disable wallet alert");
    }

    return res.json();
};